import {
  boolean,
  type InferOutput,
  literal,
  object,
  optional,
  union
} from 'valibot'

/**
 * 税区分マスタ一覧のクエリ。
 *
 * `isActive`:
 * - `true` / `false`: 有効・無効それぞれで絞り込み
 * - `'all'`: 「全て」(有効・無効すべて) を明示。 #3561 bug-1 対応で導入
 * - `undefined` (= URL クエリ空): 初回アクセス扱い。`beforeLoad` が `isActive=true` を
 *   デフォルト付与して redirect する
 *
 * 「全て」を `undefined` (= URL クエリ空) で表現すると `beforeLoad` の「初回アクセス」
 * 判定と衝突するため、明示的な sentinel リテラル `'all'` を URL に残す。
 */
export const TaxCategoriesSearchSchema = object({
  isActive: optional(union([boolean(), literal('all')]))
})

export type TaxCategoriesSearch = InferOutput<typeof TaxCategoriesSearchSchema>
